var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(!_vm.isExternal && _vm.href ? 'router-link-component' : 'html-link-component',{ref:"link",tag:"component",attrs:{"rel":_vm.isExternal ? 'noopener' : null,"href":_vm.href,"target":_vm.target,"active-class":_vm.activeClass,"exact-active-class":_vm.exactActiveClass}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }